export const pillars = ['Incident Reports', 'Training & Development', 'Equipment Readiness', 'Station Operations', 'Fire Prevention', 'Operational Planning'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'Incident Reports & Documentation (The Documentation Blueprint)',
  desc: 'Create structured starting drafts for incident narratives, chronological event summaries, post-incident documentation, and internal records. Organize the information provided into a clear format while keeping factual accuracy and department reporting requirements at the center.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Training & Professional Development (The Training Planner)',
  desc: 'Build training outlines, lesson plans, learning objectives, scenario-based exercises, and evaluation checklists. Prepare materials that can be reviewed and adapted by qualified instructors to match department standards and training objectives.'
}, {
  n: 3,
  emoji: '📕',
  title: 'Equipment Readiness & Maintenance (The Readiness Tracker)',
  desc: 'Organize equipment inventories, inspection logs, maintenance records, deficiency lists, and follow-up actions. Create clearer documentation frameworks to help teams track what needs review and what requires attention.'
}, {
  n: 4,
  emoji: '📓',
  title: 'Fire Station Operations & Administration (The Station Operations Kit)',
  desc: 'Prepare shift summaries, internal memos, meeting agendas, task trackers, scheduling drafts, and routine administrative documents. Keep everyday station workflows organized with reusable templates.'
}, {
  n: 5,
  emoji: '📗',
  title: 'Fire Prevention & Community Education (The Prevention Toolkit)',
  desc: 'Develop public education outlines, fire safety awareness materials, community outreach plans, presentation structures, and prevention campaign drafts. Adapt the language to the audience, local guidance, and approved department messaging.'
}, {
  n: 6,
  emoji: '📙',
  title: 'Operational Planning & Incident Review (The Improvement Framework)',
  desc: 'Structure planning documents, after-action review outlines, lessons-learned summaries, and operational review materials. Organize observations and follow-up actions while leaving operational decisions and formal approvals to authorized personnel.'
}];
export const volumeIncludes = ['Step-by-step Copy & Paste Prompts', 'Fill-in-the-blank brackets for fast customization', 'Structured output formats for common fire service tasks', 'Review checklists to help verify completeness and consistency'];
export const bonuses = [{
  n: '01',
  title: 'The Firefighter Training Planner™',
  desc: 'Organize training sessions, learning objectives, exercise outlines, and evaluation checklists with reusable planning frameworks.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/nogUDjDxDQwqr6vb1jaBej/Portada_de_entrenamiento_para_bomberos.webp'
}, {
  n: '02',
  title: 'The Equipment Readiness Checklist Vault™',
  desc: 'Create organized checklists for equipment inventory, inspection records, maintenance follow-ups, and readiness documentation.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/i4gig4RsQU8rMXbuqc8giE/Portada_de_entrenamiento_para_bomberos_(1).webp'
}, {
  n: '03',
  title: 'The Fire Incident Report Template Kit™',
  desc: 'Start with structured templates for incident narratives, chronological summaries, and internal documentation.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/jaqq8gyA6hqjxCA9Ki5Qgq/Portada_de_entrenamiento_para_bomberos_(2).webp'
}, {
  n: '04',
  title: 'The Firefighter AI Quick-Start Guide™',
  desc: 'Learn how to adapt prompts, provide useful context, review AI-generated drafts, and build a practical workflow with common AI tools.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/f9fAbpB2wp3F4rCe5Mou1s/Portada_de_entrenamiento_para_bomberos_(3).webp'
}];
